(function () {
  'use strict';

  if (window.__looguOutfitsV1) return;
  const instances = new Map();
  const configs = new Map();
  let sequence = 0;
  window.__looguOutfitsV1 = { instances };

  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  const numericId = (value) => /^\d+$/.test(String(value || '')) ? String(value) : '';
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  };
  const button = (className, text, label) => {
    const node = element('button', className, text);
    node.type = 'button';
    if (label) node.setAttribute('aria-label', label);
    return node;
  };
  const rootPath = () => {
    const value = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof value === 'string' && /^\/(?!\/)/.test(value) ? value.replace(/\/?$/, '/') : '/';
  };
  const decodeHandle = (value) => {
    try {
      const decoded = decodeURIComponent(String(value));
      // Shopify handles may contain Unicode, including the existing “副本” suffix.
      return decoded && decoded !== '.' && decoded !== '..' && !/[\s/\\?#&:%<>"'\u0000-\u001f\u007f]/u.test(decoded) ? decoded : '';
    } catch (_) { return ''; }
  };
  const getHandle = (item) => {
    if (!item.handle) return '';
    const value = String(item.handle);
    const direct = decodeHandle(value);
    if (direct) return direct;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return '';
      const match = url.pathname.match(/\/products\/([^/]+)\/?$/i);
      return match ? decodeHandle(match[1]) : '';
    } catch (_) { return ''; }
  };
  const productPath = (item, variantId) => {
    const handle = getHandle(item);
    if (!handle) return '';
    let selected = numericId(variantId);
    if (!selected && item.url) {
      try {
        const source = new URL(item.url, location.origin);
        if (source.origin === location.origin && getHandle({ handle: source.href }) === handle) {
          selected = numericId(source.searchParams.get('variant'));
        }
      } catch (_) { /* An invalid optional URL never becomes a link. */ }
    }
    return rootPath() + 'products/' + encodeURIComponent(handle) + (selected ? '?variant=' + selected : '');
  };
  const requestJSON = async (url, options) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, Object.assign({ credentials: 'same-origin', signal: controller.signal }, options));
      let data;
      try { data = await response.json(); } catch (_) { throw new Error('The store returned an unreadable response. Please try again.'); }
      if (!response.ok || (data && Number(data.status) >= 400)) {
        const message = data && (data.description || data.message);
        throw new Error(typeof message === 'string' ? message : 'This request could not be completed. Please try again.');
      }
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The request timed out. Please try again.');
      throw error;
    } finally { clearTimeout(timeout); }
  };

  class OutfitSection {
    constructor(section) {
      this.section = section;
      this.mount = section.querySelector('[data-loogu-outfits-mount]');
      this.id = 'loogu-outfits-' + (++sequence);
      this.filterId = this.id + '-cutout';
      this.productId = String(section.dataset.productId || '');
      this.context = {};
      try { this.context = JSON.parse(section.querySelector('[data-loogu-product-context]').textContent); } catch (_) { /* An absent context still permits product-ID matching. */ }
      this.context.variants = Array.isArray(this.context.variants) ? this.context.variants : [];
      this.variantIds = new Set(this.context.variants.map((variant) => String(variant.id)));
      this.selectedVariantId = String(this.context.selectedVariantId || '');
      this.colorIndex = Number.isInteger(this.context.colorOptionIndex) ? this.context.colorOptionIndex : -1;
      this.activeDialog = null;
      this.disposed = false;
      this.load();
    }

    async load() {
      if (!this.mount || !this.productId || !this.section.dataset.configUrl) return;
      try {
        const url = new URL(this.section.dataset.configUrl, location.href);
        if (!['http:', 'https:'].includes(url.protocol)) return;
        if (!configs.has(url.href)) configs.set(url.href, requestJSON(url.href).catch((error) => { configs.delete(url.href); throw error; }));
        const config = await configs.get(url.href);
        if (this.disposed || !config || config.version !== 1 || !Array.isArray(config.looks)) return;
        this.relatedLooks = config.looks.filter((look) => look && Array.isArray(look.items) && look.items.some((item) => Array.isArray(item.productIds) && item.productIds.some((id) => String(id) === this.productId)));
        if (!this.relatedLooks.length) return;
        this.render();
      } catch (error) {
        console.warn('[LOOGU outfits] Unable to load looks.', error.message);
      }
    }

    selectedColor() {
      const variant = this.context.variants.find((entry) => String(entry.id) === this.selectedVariantId);
      return variant && Array.isArray(variant.options) && this.colorIndex >= 0 ? normalize(variant.options[this.colorIndex]) : '';
    }

    onVariant(variant) {
      if (!variant || !this.variantIds.has(String(variant.id))) return;
      const previous = this.selectedColor();
      this.selectedVariantId = String(variant.id);
      if (this.relatedLooks && previous !== this.selectedColor()) this.render();
    }

    imageURL(item) {
      if (!item.image || !/^[a-z0-9][a-z0-9_.-]*\.(?:webp|png|jpe?g|avif|svg)$/i.test(String(item.image))) return '';
      try {
        const base = new URL(this.section.dataset.assetRoot, location.href);
        if (!['http:', 'https:'].includes(base.protocol)) return '';
        base.search = '';
        base.hash = '';
        if (!base.pathname.endsWith('/')) base.pathname += '/';
        return new URL(String(item.image), base).href;
      } catch (_) { return ''; }
    }

    appendFilter(parent) {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('class', 'loogu-outfits__filter');
      svg.setAttribute('width', '0');
      svg.setAttribute('height', '0');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const defs = document.createElementNS(ns, 'defs');
      const filter = document.createElementNS(ns, 'filter');
      Object.entries({ id: this.filterId, x: '0', y: '0', width: '100%', height: '100%', 'color-interpolation-filters': 'sRGB' }).forEach(([key, value]) => filter.setAttribute(key, value));
      const add = (tag, attributes, target) => {
        const node = document.createElementNS(ns, tag);
        Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
        (target || filter).append(node);
        return node;
      };
      add('feColorMatrix', { in: 'SourceGraphic', type: 'matrix', values: '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -.333333 -.333333 -.333333 0 1', result: 'key' });
      const transfer = add('feComponentTransfer', { in: 'key', result: 'mask' });
      add('feFuncA', { type: 'linear', slope: '25', intercept: '-.8' }, transfer);
      add('feFlood', { 'flood-color': '#c3c4c3', result: 'card-tone' });
      add('feBlend', { in: 'SourceGraphic', in2: 'card-tone', mode: 'darken', result: 'toned' });
      add('feComposite', { in: 'toned', in2: 'mask', operator: 'in', result: 'cutout' });
      add('feComposite', { in: 'cutout', in2: 'SourceGraphic', operator: 'in' });
      defs.append(filter);
      svg.append(defs);
      parent.append(svg);
    }

    render() {
      if (this.activeDialog) this.closeDialog();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      const color = this.selectedColor();
      const matched = this.relatedLooks.filter((look) => normalize(look.color) === color || look.items.some((item) => Array.isArray(item.productIds) && item.productIds.some((id) => String(id) === this.productId) && (normalize(item.color) === color || Array.isArray(item.allowedColors) && item.allowedColors.some((value) => normalize(value) === color))));
      const looks = color && matched.length ? matched : this.relatedLooks;
      this.mount.replaceChildren();
      this.appendFilter(this.mount);
      const shell = element('div', 'loogu-outfits__shell');
      const heading = element('h2', 'loogu-outfits__heading', 'Complete Your Hunt');
      heading.id = this.id + '-heading';
      this.section.setAttribute('aria-labelledby', heading.id);
      shell.append(heading, element('p', 'loogu-outfits__intro', 'Explore the look. Choose your gear.'));
      if (looks.length === 1) {
        const showcase = element('div', 'loogu-outfits__single');
        const visual = element('div', 'loogu-outfits__single-visual');
        visual.setAttribute('role', 'list');
        visual.setAttribute('aria-label', 'Coordinated hunting look');
        visual.append(this.createCard(looks[0]));
        showcase.append(visual, this.createProductPanel(looks[0]));
        shell.append(showcase);
        this.mount.append(shell);
        this.section.hidden = false;
        return;
      }
      const carousel = element('div', 'loogu-outfits__carousel');
      const track = element('div', 'loogu-outfits__track');
      track.id = this.id + '-track';
      track.dataset.count = String(looks.length);
      track.setAttribute('role', 'list');
      track.setAttribute('aria-label', 'Coordinated hunting looks');
      const previous = button('loogu-outfits__arrow loogu-outfits__arrow--previous', '‹', 'Previous looks');
      const next = button('loogu-outfits__arrow loogu-outfits__arrow--next', '›', 'Next looks');
      [previous, next].forEach((control) => control.setAttribute('aria-controls', track.id));
      const scroll = (direction) => {
        const first = track.firstElementChild;
        if (!first) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      const updateArrows = () => {
        const hasOverflow = track.scrollWidth - track.clientWidth > 2;
        previous.hidden = !hasOverflow;
        next.hidden = !hasOverflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      track.addEventListener('scroll', updateArrows, { passive: true });
      looks.forEach((look) => track.append(this.createCard(look)));
      carousel.append(previous, track, next);
      shell.append(carousel);
      this.mount.append(shell);
      this.section.hidden = false;
      requestAnimationFrame(updateArrows);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateArrows);
        this.resizeObserver.observe(track);
      }
    }

    createProductPanel(look) {
      const panel = element('aside', 'loogu-outfits__panel');
      const title = element('h3', 'loogu-outfits__panel-title', 'In this look');
      title.id = this.id + '-panel-title';
      panel.setAttribute('aria-labelledby', title.id);
      panel.append(title, element('p', 'loogu-outfits__panel-intro', 'Explore each piece, or choose your sizes to shop the look.'));
      const list = element('ul', 'loogu-outfits__panel-list');
      look.items.forEach((item) => {
        const row = element('li', 'loogu-outfits__panel-row');
        const href = productPath(item);
        const content = element(href ? 'a' : 'div', 'loogu-outfits__panel-product');
        if (href) content.href = href;
        const thumbnail = element('span', 'loogu-outfits__panel-thumbnail');
        const image = this.imageURL(item);
        if (image) {
          const img = element('img');
          img.src = image;
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.style.filter = 'url(#' + this.filterId + ')';
          if (item.flip) img.style.transform = 'scaleX(-1)';
          thumbnail.append(img);
        } else {
          thumbnail.append(element('span', '', 'Image unavailable'));
        }
        const details = element('span', 'loogu-outfits__panel-details');
        if (item.code) details.append(element('span', 'loogu-outfits__panel-code', item.code));
        details.append(element('span', 'loogu-outfits__panel-name', item.name || item.code || 'Gear'));
        if (item.color || look.color) details.append(element('span', 'loogu-outfits__panel-color', item.color || look.color));
        if (!href) details.append(element('span', 'loogu-outfits__panel-unavailable', 'Not available online'));
        content.append(thumbnail, details);
        if (href) {
          const arrow = element('span', 'loogu-outfits__panel-link', '\u2192');
          arrow.setAttribute('aria-hidden', 'true');
          content.append(arrow);
        }
        row.append(content);
        list.append(row);
      });
      const choose = button('loogu-outfits__panel-shop', 'Choose sizes & shop');
      choose.setAttribute('aria-haspopup', 'dialog');
      choose.addEventListener('click', () => this.openDialog(look, choose));
      panel.append(list, choose);
      return panel;
    }

    createCard(look) {
      const card = element('article', 'loogu-outfits__card');
      card.setAttribute('role', 'listitem');
      const caption = element('div', 'loogu-outfits__caption');
      caption.append(element('h3', 'loogu-outfits__name', look.name || 'Hunting Look'));
      if (look.color) caption.append(element('p', 'loogu-outfits__color', look.color));
      const art = element('div', 'loogu-outfits__art');
      look.items.forEach((item) => {
        // Added online products without approved coordinates belong only in the dialog.
        if (!['x', 'y', 'w', 'h'].every((key) => item[key] !== null && item[key] !== undefined && Number.isFinite(Number(item[key]))) || Number(item.w) <= 0 || Number(item.h) <= 0) return;
        const image = this.imageURL(item);
        const href = productPath(item);
        const slot = element('div', 'loogu-outfits__slot');
        ['x', 'y', 'w', 'h'].forEach((key) => {
          const value = Number(item[key]);
          slot.style.setProperty('--' + key, (Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0) + '%');
        });
        const stacking = Number(item.z);
        slot.style.zIndex = String(Number.isFinite(stacking) ? Math.max(0, Math.min(99, stacking)) : 1);
        const media = element(href ? 'a' : 'span', 'loogu-outfits__item-media');
        if (href) { media.href = href; media.setAttribute('aria-label', 'View ' + (item.name || item.code || 'product')); }
        if (image) {
          const img = element('img');
          img.src = image;
          img.alt = item.name || item.code || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.style.filter = 'url(#' + this.filterId + ')';
          if (item.flip) img.style.transform = 'scaleX(-1)';
          media.append(img);
        } else {
          const missing = element('span', 'loogu-outfits__missing');
          missing.append(element('strong', '', item.code || item.name || 'Gear'), element('span', '', href ? 'Image unavailable' : 'Not available online'));
          media.append(missing);
        }
        const hot = button('loogu-outfits__hotspot', '+', 'Shop this look: ' + (item.name || item.code || 'gear'));
        hot.setAttribute('aria-haspopup', 'dialog');
        hot.addEventListener('click', () => this.openDialog(look, hot, String(item.id)));
        slot.append(media, hot);
        art.append(slot);
      });
      const cta = button('loogu-outfits__shop', 'Shop The Look');
      cta.setAttribute('aria-haspopup', 'dialog');
      cta.addEventListener('click', () => this.openDialog(look, cta));
      art.append(cta);
      card.append(caption, art);
      return card;
    }

    async openDialog(look, opener, focusItemId) {
      if (this.activeDialog) this.closeDialog();
      const dialog = element('dialog', 'loogu-outfits__dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', this.id + '-dialog-title');
      const head = element('div', 'loogu-outfits__dialog-head');
      const titles = element('div');
      const title = element('h3', '', look.name || 'Shop The Look');
      title.id = this.id + '-dialog-title';
      titles.append(element('p', 'loogu-outfits__eyebrow', 'Shop The Look'), title);
      if (look.color) titles.append(element('p', 'loogu-outfits__dialog-color', look.color));
      const close = button('loogu-outfits__close', '×', 'Close Shop The Look');
      close.addEventListener('click', () => this.closeDialog());
      head.append(titles, close);
      const list = element('div', 'loogu-outfits__items');
      const footer = element('div', 'loogu-outfits__dialog-footer');
      const total = element('p', 'loogu-outfits__total');
      const status = element('p', 'loogu-outfits__status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      const add = button('loogu-outfits__add', 'Add selected to cart');
      add.disabled = true;
      footer.append(total, element('p', 'loogu-outfits__purchase-note', 'Choose a size for each selected item. Prices are shown in your store currency.'), status, add);
      dialog.append(head, list, footer);
      const state = { dialog, opener, rows: [], total, status, add, loading: true, busy: false, currency: '', focusItemId };
      this.activeDialog = state;
      state.currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '';
      look.items.forEach((item) => state.rows.push(this.createRow(item, look, list, state)));
      add.addEventListener('click', () => this.addSelected(state));
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDialog(); });
      dialog.addEventListener('close', () => { if (this.activeDialog === state) this.closeDialog(); });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeDialog();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); this.closeDialog(); return; }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), [tabindex="0"]')).filter((node) => !node.hidden && node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); if (last) last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); if (first) first.focus(); }
      });
      this.section.append(dialog);
      state.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else { dialog.setAttribute('open', ''); dialog.setAttribute('role', 'dialog'); }
      close.focus();
      status.textContent = 'Loading current prices and availability…';
      const productRequests = new Map();
      await Promise.all(state.rows.map(async (row) => {
        if (!row.handle) return;
        try {
          if (!productRequests.has(row.handle)) productRequests.set(row.handle, requestJSON(rootPath() + 'products/' + encodeURIComponent(row.handle) + '.js', { cache: 'no-store' }));
          const product = await productRequests.get(row.handle);
          if (this.activeDialog !== state) return;
          this.populateRow(row, product, state);
        } catch (error) {
          if (this.activeDialog !== state) return;
          row.note.textContent = 'Unable to load this item. ' + error.message;
          row.note.classList.add('loogu-outfits__row-error');
          if (!row.image) row.thumbnail.replaceChildren(element('span', '', 'Image unavailable'));
          row.checkbox.disabled = true;
          row.checkbox.checked = false;
        }
      }));
      if (this.activeDialog !== state) return;
      state.loading = false;
      status.textContent = '';
      this.updateSelection(state);
      if (focusItemId !== undefined) {
        const row = state.rows.find((entry) => String(entry.item.id) === focusItemId);
        if (row) { row.node.scrollIntoView({ block: 'nearest' }); row.node.focus({ preventScroll: true }); }
      }
    }

    createRow(item, look, list, state) {
      const node = element('div', 'loogu-outfits__product');
      node.tabIndex = -1;
      const checkbox = element('input', 'loogu-outfits__checkbox');
      checkbox.type = 'checkbox';
      checkbox.disabled = true;
      checkbox.setAttribute('aria-label', 'Include ' + (item.name || item.code || 'item'));
      checkbox.addEventListener('change', () => this.updateSelection(state));
      const image = this.imageURL(item);
      const thumbnail = element('div', 'loogu-outfits__thumbnail');
      if (image) {
        const img = element('img');
        img.src = image;
        img.alt = '';
        img.loading = 'lazy';
        thumbnail.append(img);
      } else { thumbnail.append(element('span', '', getHandle(item) ? 'Loading image…' : 'Not available online')); }
      const content = element('div', 'loogu-outfits__product-info');
      const name = element('h4', '', item.name || item.code || 'Gear');
      const role = item.role === 'optional' ? 'Optional add-on' : item.role === 'accessory' ? 'Accessory' : 'Core piece';
      content.append(element('p', 'loogu-outfits__role', role), name);
      if (item.color || look.color) content.append(element('p', 'loogu-outfits__item-color', item.color || look.color));
      const price = element('p', 'loogu-outfits__price');
      const note = element('p', 'loogu-outfits__availability', 'Loading…');
      const options = element('div', 'loogu-outfits__options');
      const href = productPath(item);
      let link = null;
      if (href) { link = element('a', 'loogu-outfits__view', 'View product'); link.href = href; }
      content.append(price, options, note);
      if (link) content.append(link);
      const row = { item, look, node, checkbox, image, thumbnail, handle: getHandle(item), content, price, note, options, link, variants: [], chosen: null };
      if (!row.handle) { note.textContent = 'Not available online'; node.classList.add('loogu-outfits__product--unavailable'); }
      node.append(checkbox, thumbnail, content);
      list.append(node);
      return row;
    }

    populateRow(row, product, state) {
      if (!product || !Array.isArray(product.variants)) throw new Error('Product details are unavailable.');
      const ids = Array.isArray(row.item.productIds) ? row.item.productIds.map(String) : [];
      if (!ids.length || !ids.includes(String(product.id))) throw new Error('This product no longer matches the look.');
      const optionNames = (Array.isArray(product.options) ? product.options : []).map((option) => typeof option === 'string' ? option : option.name);
      const colorIndex = optionNames.findIndex((name) => /(?:colou?r|camo|pattern|颜色|顏色|花色)/i.test(String(name)));
      const allowedIds = Array.isArray(row.item.allowedVariantIds) ? new Set(row.item.allowedVariantIds.map(numericId).filter(Boolean)) : null;
      const desiredColors = (Array.isArray(row.item.allowedColors) && row.item.allowedColors.length ? row.item.allowedColors : [row.item.color || row.look.color]).map(normalize).filter(Boolean);
      row.variants = product.variants.filter((variant) => {
        const id = numericId(variant.id);
        if (!id) return false;
        if (allowedIds) return allowedIds.has(id);
        const actualColor = normalize(Array.isArray(variant.options) ? variant.options[colorIndex] : variant['option' + (colorIndex + 1)]);
        return colorIndex < 0 || !desiredColors.length || desiredColors.includes(actualColor);
      });
      row.liveImage = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
      this.updateLiveThumbnail(row, row.variants.find((variant) => variant.available === true) || row.variants[0]);
      const available = row.variants.filter((variant) => variant.available === true);
      if (!row.variants.length) { row.note.textContent = 'This color is currently unavailable.'; return; }
      if (!available.length) { row.note.textContent = 'Sold out in this color.'; row.node.classList.add('loogu-outfits__product--unavailable'); return; }
      row.checkbox.disabled = false;
      row.checkbox.checked = row.item.role !== 'optional';
      const variantLabel = (variant) => {
        const values = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(Boolean);
        const details = values.map((value, index) => index !== colorIndex && normalize(value) !== 'default title' ? (optionNames[index] ? optionNames[index] + ': ' : '') + (normalize(value) === 'one size' ? 'ONE SIZE' : value) : '').filter(Boolean);
        return details.join(' / ') || 'ONE SIZE';
      };
      if (available.length === 1) {
        row.chosen = available[0];
        row.options.append(element('p', 'loogu-outfits__single-option', variantLabel(row.chosen)));
        row.note.textContent = 'Available';
      } else {
        const label = element('label', 'loogu-outfits__select-label', 'Choose size / option');
        const select = element('select', 'loogu-outfits__select');
        select.id = this.id + '-option-' + state.rows.indexOf(row);
        label.htmlFor = select.id;
        const placeholder = element('option', '', 'Select an option');
        placeholder.value = '';
        select.append(placeholder);
        row.variants.forEach((variant) => {
          const option = element('option', '', variantLabel(variant) + (variant.available === true ? '' : ' — Sold out'));
          option.value = String(variant.id);
          option.disabled = variant.available !== true;
          select.append(option);
        });
        select.addEventListener('change', () => {
          row.chosen = available.find((variant) => String(variant.id) === select.value) || null;
          this.updateRowPrice(row, state);
          this.updateSelection(state);
        });
        row.select = select;
        row.options.append(label, select);
        row.note.textContent = 'Choose an option to add this item.';
      }
      this.updateRowPrice(row, state);
    }

    money(cents, state) {
      const value = Number(cents);
      if (!Number.isFinite(value)) return '';
      if (/^[A-Z]{3}$/.test(state.currency)) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: state.currency }).format(value / 100); } catch (_) { /* Plain decimal fallback avoids guessing a currency. */ }
      }
      return (value / 100).toFixed(2);
    }

    updateLiveThumbnail(row, variant) {
      if (row.image) return;
      const source = variant && variant.featured_image || row.liveImage;
      const raw = source && typeof source === 'object' ? source.src || source.url : source;
      try {
        const url = new URL(raw || '', location.origin);
        if (!raw || !['http:', 'https:'].includes(url.protocol)) throw new Error('No image');
        const img = element('img');
        img.src = url.href;
        img.alt = '';
        img.loading = 'lazy';
        row.thumbnail.replaceChildren(img);
      } catch (_) { row.thumbnail.replaceChildren(element('span', '', 'Image unavailable')); }
    }

    updateRowPrice(row, state) {
      const available = row.variants.filter((variant) => variant.available === true);
      if (row.chosen) {
        this.updateLiveThumbnail(row, row.chosen);
        row.price.textContent = this.money(row.chosen.price, state);
        row.note.textContent = 'Available';
        if (row.link) row.link.href = productPath(row.item, row.chosen.id);
      } else {
        const prices = available.map((variant) => Number(variant.price)).filter(Number.isFinite);
        row.price.textContent = prices.length ? 'From ' + this.money(Math.min.apply(null, prices), state) : '';
        row.note.textContent = 'Choose an option to add this item.';
        if (row.link) row.link.href = productPath(row.item);
      }
    }

    updateSelection(state) {
      if (this.activeDialog !== state) return;
      const selected = state.rows.filter((row) => row.checkbox.checked && !row.checkbox.disabled);
      const incomplete = selected.filter((row) => !row.chosen);
      state.rows.forEach((row) => row.node.classList.toggle('loogu-outfits__product--selected', row.checkbox.checked));
      const sum = selected.reduce((total, row) => total + (row.chosen ? Number(row.chosen.price) || 0 : 0), 0);
      state.total.textContent = incomplete.length ? 'Choose options for ' + incomplete.length + ' selected item' + (incomplete.length === 1 ? '' : 's') + '.' : selected.length ? 'Selected items: ' + this.money(sum, state) : 'Select the items you want.';
      state.add.disabled = state.loading || state.busy || !selected.length || !!incomplete.length;
      state.add.textContent = state.busy ? 'Adding…' : 'Add selected to cart';
    }

    async addSelected(state) {
      if (state.busy || state.loading || this.activeDialog !== state) return;
      const selected = state.rows.filter((row) => row.checkbox.checked && !row.checkbox.disabled);
      if (!selected.length || selected.some((row) => !row.chosen || row.chosen.available !== true || !numericId(row.chosen.id))) { this.updateSelection(state); return; }
      const combined = new Map();
      selected.forEach((row) => {
        const id = String(row.chosen.id);
        if (combined.has(id)) combined.get(id).quantity += 1;
        else combined.set(id, { id, quantity: 1 });
      });
      state.busy = true;
      state.status.textContent = '';
      state.status.classList.remove('loogu-outfits__status--error');
      this.updateSelection(state);
      state.rows.forEach((row) => { row.wasDisabled = row.checkbox.disabled; row.checkbox.disabled = true; if (row.select) row.select.disabled = true; });
      try {
        await requestJSON(rootPath() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: Array.from(combined.values()) }) });
        state.status.textContent = 'Added to cart. Opening your cart…';
        location.assign(rootPath() + 'cart');
      } catch (error) {
        if (this.activeDialog !== state) return;
        state.status.textContent = error.message + ' Your cart may have changed; check your cart before trying again.';
        const cartLink = element('a', 'loogu-outfits__view', 'View cart');
        cartLink.href = rootPath() + 'cart';
        state.status.append(document.createTextNode(' '), cartLink);
        state.status.classList.add('loogu-outfits__status--error');
        state.busy = false;
        state.rows.forEach((row) => { row.checkbox.disabled = row.wasDisabled; if (row.select) row.select.disabled = false; });
        this.updateSelection(state);
      }
    }

    closeDialog() {
      const state = this.activeDialog;
      if (!state) return;
      this.activeDialog = null;
      if (typeof state.dialog.close === 'function' && state.dialog.open) state.dialog.close();
      state.dialog.remove();
      document.body.style.overflow = state.previousOverflow;
      if (state.opener && state.opener.isConnected) state.opener.focus({ preventScroll: true });
    }

    destroy() {
      this.disposed = true;
      this.closeDialog();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      instances.delete(this.section);
    }
  }

  function initialize(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-loogu-outfits]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll('[data-loogu-outfits]'));
    roots.forEach((section) => { if (!instances.has(section)) instances.set(section, new OutfitSection(section)); });
    instances.forEach((instance, section) => { if (!section.isConnected) instance.destroy(); });
  }
  // Concept dispatches variant:change on its product form without bubbling.
  // Capture phase receives it, while known variant IDs scope it to this product.
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    instances.forEach((instance) => instance.onVariant(variant));
  }, true);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => instances.forEach((instance, section) => { if (section === event.target || event.target.contains(section)) instance.destroy(); }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
}());
